module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-7.64871317.png";